export default class Tooltip {
    constructor() {
      this.tooltip = document.createElement('div');
      this.tooltip.style.position = 'absolute';
      this.tooltip.style.visibility = 'hidden';
      this.tooltip.classList.add('monitor-apps-tooltip');
    }
  
    show(text,target) {
      this.tooltip.textContent = text;
      this.tooltip.style.visibility = 'hidden';
      this.tooltip.style.display = 'block';
  
      const { width, height } = this.tooltip.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
  
      let tooltipX = targetRect.left + window.scrollX - width - 10;
      let tooltipY = targetRect.top + window.scrollY + (targetRect.height / 2) - (height / 2);
      
      this.tooltip.classList.remove(
        'monitor-apps-tooltip-left', 
        'monitor-apps-tooltip-right', 
        'monitor-apps-tooltip-top', 
        'monitor-apps-tooltip-bottom'
      );
  
      if (tooltipX < 0) {
        tooltipX = targetRect.right + window.scrollX + 10;
        this.tooltip.classList.add('monitor-apps-tooltip-right');
      } else {
        this.tooltip.classList.add('monitor-apps-tooltip-left');
      }

      if (tooltipY < 0) {
        tooltipY = targetRect.bottom + window.scrollY + 10; 
        this.tooltip.classList.add('monitor-apps-tooltip-bottom');
      } else if (tooltipY + height > window.innerHeight + window.scrollY) {
        tooltipY = targetRect.top + window.scrollY - height - 10;
        this.tooltip.classList.add('monitor-apps-tooltip-top');
      }

      if (tooltipX + width > window.innerWidth + window.scrollX) {
        tooltipX = window.innerWidth + window.scrollX - width;
      }
      if (tooltipY + height > window.innerHeight + window.scrollY) {
        tooltipY = window.innerHeight + window.scrollY - height;
      }
  
      this.tooltip.style.left = `${tooltipX}px`;
      this.tooltip.style.top = `${tooltipY}px`;
      this.tooltip.style.visibility = 'visible';
      this.tooltip.classList.add('visible');
    }
  
    hide() {
      this.tooltip.style.display = 'none';
      this.tooltip.classList.remove('visible');
    }
  }